var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Checkbox from 'antd/lib/checkbox';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Input from 'antd/lib/input';
import Radio from 'antd/lib/radio';
import Select from 'antd/lib/select';
import { polyfill } from 'react-lifecycles-compat';
import Icon from './Icon';
import Color from './Color';
import RowHelp from './RowHelp';
import SelectInput from './SelectInput';
import { alphaBg, unitToPercent, colorLookup, colorExp, linearGradientToDeg, getRadioButton, getOptionArray, getOption } from '../../utils';
var Option = Select.Option;
var InputGroup = Input.Group;
var RadioButton = Radio.Button;
var RadioGroup = Radio.Group;
var GradientEdit = /** @class */ (function (_super) {
    __extends(GradientEdit, _super);
    function GradientEdit(props) {
        var _this = _super.call(this, props) || this;
        _this.onBarClick = function (e) {
            var gradient = _this.state.gradient;
            var rect = _this.bar.getBoundingClientRect();
            var x = e.clientX || e.pageX;
            var currentPercent = (((x - rect.x) / rect.width) * 100).toFixed(2);
            var current = ['black', currentPercent + "%"];
            // const index = gradient.filter(c => (parseFloat(c[1])) < currentPercent).length - 1;
            // gradient.splice(index, 0, current);
            gradient.push(current);
            gradient.sort(function (a, b) { return parseFloat(a[1]) - parseFloat(b[1]); });
            _this.setState({
                gradient: gradient,
                active: gradient.findIndex(function (c) { return c === current; }),
            }, _this.onChange);
        };
        _this.onPointClick = function (e, i) {
            _this.setState({
                active: i
            });
            var gradient = _this.state.gradient;
            _this.isDrag = true;
            _this.current = gradient[i][1];
            _this.pos = {
                x: e.clientX || e.pageX,
                y: e.clientY || e.pageY,
            };
            _this.barRect = _this.bar.getBoundingClientRect();
            _this.percentRef.state.value = parseFloat(_this.current) || (i ? 100 : 0);
        };
        _this.onPointUp = function (e) {
            if (_this.isDrag) {
                var _a = _this.state, active = _a.active, gradient = _a.gradient;
                var y = e.clientY || e.pageY;
                var differ = Math.abs(y - _this.pos.y);
                if (differ > 40 && gradient.length > 2) {
                    gradient.splice(active, 1);
                    _this.setState({
                        active: 0,
                        gradient: gradient,
                    }, _this.onChange);
                }
                _this.isDrag = false;
                _this.pos = {};
                _this.onChange();
            }
        };
        _this.onPointMove = function (e) {
            if (_this.isDrag) {
                var _a = _this.state, i = _a.active, g = _a.gradient;
                var gradient = __spreadArrays(g);
                var x = e.clientX || e.pageX;
                var rect = _this.barRect; // this.bar.getBoundingClientRect();
                var w = rect.width - 8;
                // 只支持百分比，不对 px 做处理；
                var p = _this.current ? parseFloat(_this.current) / 100 : 0;
                p = p > 1 ? 1 : p;
                p = p < 0 ? 0 : p;
                var differ = x - _this.pos.x + (p * w);
                differ = differ / w * 100;
                differ = differ > 100 ? 100 : differ;
                differ = differ < 0 ? 0 : differ;
                var str = i ? '100%' : '0%';
                gradient[i][1] = differ ? differ + "%" : str;
                var gradientCurrent_1 = gradient[i];
                gradient.sort(function (a, b) {
                    return (parseFloat(a[1]) - parseFloat(b[1]));
                });
                var active = gradient.findIndex(function (t) { return t === gradientCurrent_1; });
                // 控制 ref 里的 state，在下一次 render 时更新 defaultValue 的值；
                _this.percentRef.state.value = differ || parseFloat(str);
                _this.active = active;
                _this.setState({
                    gradient: gradient,
                    active: active
                }, function () {
                    _this.onChange(true);
                });
            }
        };
        _this.onPercentChange = function () {
            _this.isPressEnter = false;
        };
        _this.onPercentBlur = function (e) {
            if (!_this.isPressEnter) {
                var v = e.target.value.replace(/[^0-9.-]/g, '');
                var _a = _this.state, active = _a.active, gradient = _a.gradient;
                gradient[active][1] = (v || 0) + "%";
                _this.percentRef.state.value = v || 0;
                _this.setState({
                    gradient: gradient,
                }, _this.onChange);
            }
        };
        _this.onPercentPressEnter = function (e) {
            _this.onPercentBlur(e);
            _this.isPressEnter = true;
        };
        _this.onColorChange = function (e, isDrag) {
            var _a = _this.state, active = _a.active, gradient = _a.gradient;
            gradient[active][0] = e;
            _this.setState({
                gradient: gradient,
            }, function () {
                _this.onChange(isDrag);
            });
        };
        _this.onRepeatChange = function (e) {
            _this.setState({
                repeat: e.target.checked,
            }, _this.onChange);
        };
        _this.onChangeType = function (key, v) {
            var contentType = _this.state.type;
            var type = _this.props.type;
            if (type === 'linear') {
                var _a = _this.getLinearFeat(contentType), value = _a.value, uint = _a.uint;
                switch (key) {
                    case 'deg':
                        value = linearGradientToDeg[v] || linearGradientToDeg[v] === 0 ? linearGradientToDeg[v] : v || 0;
                        break;
                    case 'uint':
                        uint = v || 'deg';
                        break;
                    default:
                        break;
                }
                contentType = ("" + value + (value || value === 0 ? uint || 'deg' : '')).trim();
            }
            else {
                var _b = _this.getRadialFeat(contentType), shape = _b.shape, extent = _b.extent, position = _b.position;
                switch (key) {
                    case 'shape':
                        shape = v === _this.shape[0] ? '' : v;
                        break;
                    case 'extent':
                        extent = v === _this.extent[0] ? '' : v;
                        break;
                    case 'position':
                        position = v === 'center' ? '' : v;
                        break;
                    default:
                        break;
                }
                contentType = (shape + " " + extent + " " + (position ? 'at' : '') + " " + position).trim();
            }
            _this.setState({
                type: contentType,
            }, _this.onChange);
        };
        _this.onChange = function (isDrag) {
            var _a = _this.props, type = _a.type, value = _a.value, num = _a.num, onChange = _a.onChange;
            var _b = _this.state, contentType = _b.type, gradient = _b.gradient, repeat = _b.repeat;
            var name = "" + (repeat ? 'repeating-' : '') + type + "-gradient";
            var gradientStr = name + "(" + (contentType ? contentType + ", " : '') + gradient.map(function (c) { return c.join(' '); }).join(',') + ")";
            value.image[num] = gradientStr;
            if (onChange) {
                onChange(value, isDrag);
            }
        };
        _this.getGradientData = function (props) {
            var value = props.value, num = props.num;
            var gradientArray = _this.getGradientArray(props);
            var isRadial = gradientArray[0].match(/at|circle|ellipse/);
            var isLinear = gradientArray[0].match(/deg|turn|rad|grad|to\s+[a-z]/g);
            var type = isRadial || isLinear ? gradientArray.shift() : '';
            var gradient = gradientArray.map(function (str, i) {
                var $str = str.replace(colorExp, function (e) { return e.replace(/\s+/g, ''); });
                var item = $str.split(' ');
                if (!item[1]) {
                    if (!i) {
                        item[1] = '0%';
                    }
                    else if (i === gradientArray.length - 1) {
                        item[1] = '100%';
                    }
                    else {
                        console.error("gradient error: " + props.value.image[props.num]);
                    }
                }
                var uint = item[1].replace(/[\d+.-]/g, '');
                if (uint !== '%') {
                    item[1] = unitToPercent(props.editorElem, item[1], uint);
                }
                return item;
            });
            return {
                type: type,
                gradient: gradient,
                repeat: !!value.image[num].match(/^repeating/),
            };
        };
        _this.getRadialFeat = function (contentType) {
            var typeArray = contentType.split(' at ');
            var shapeOrExtent = typeArray[0].split(' ');
            var shape = _this.shape.indexOf(shapeOrExtent[0]) >= 0 ? shapeOrExtent[0] : '';
            var extent = shapeOrExtent[1] && _this.extent.indexOf(shapeOrExtent[1]) >= 0 ? shapeOrExtent[1] : '';
            extent = shapeOrExtent[0] && _this.extent.indexOf(shapeOrExtent[0]) >= 0 ? shapeOrExtent[0] : extent;
            var position = typeArray[1] || '';
            return {
                shape: shape,
                extent: extent,
                position: position,
            };
        };
        _this.getLinearFeat = function (contentType) {
            var str = contentType.match(/deg|turn|rad|grad/) ? contentType : linearGradientToDeg[contentType] || '';
            var value = parseFloat(str) || parseFloat(str) === 0 ? parseFloat(str) : '';
            var uint = str.toString().replace(/[^a-z]/ig, '');
            if (uint === 'turn') {
                console.warn('不支持 turn 为单位，自动转换为 deg');
                uint = 'deg';
            }
            return {
                value: value,
                uint: uint,
            };
        };
        _this.getGradientArray = function (_a) {
            var value = _a.value, num = _a.num;
            return value.image[num].replace(/.*gradient\((.*)\)/, '$1').split(/,\s?(?=[a-z#])/g);
        };
        _this.getFeatChildToRender = function () {
            /**
             * 圆形渐变
             * (shape extent-keyword at position, color)
             * 线性渐变
             * (side-or-corner || angle, color position) // 颜色后面只支持一个位置百分比; 只支持渐变的效果，画栅格可以加点。
             */
            var _a = _this.props, type = _a.type, className = _a.className, locale = _a.locale;
            var contentType = _this.state.type;
            if (type === 'linear') {
                var _b = _this.getLinearFeat(contentType), uint = _b.uint, value = _b.value;
                return (React.createElement("div", { className: className + "-feat" },
                    React.createElement(RowHelp, { title: React.createElement(Icon, { type: "reload", prompt: locale.angle }), help: locale.angleHelp },
                        React.createElement(InputGroup, { compact: true },
                            React.createElement(SelectInput, { style: { width: 'calc(100% - 60px)' }, value: value.toString(), size: "small", onChange: function (e) {
                                    _this.onChangeType('deg', e);
                                } }, getOption(linearGradientToDeg)),
                            React.createElement(Select, { size: "small", value: uint || 'deg', style: { width: 60 }, onChange: function (e) {
                                    _this.onChangeType('uint', e);
                                } },
                                React.createElement(Option, { value: "deg" }, "deg"),
                                React.createElement(Option, { value: "rad" }, "rad"),
                                React.createElement(Option, { value: "grad" }, "grad"))))));
            }
            var _c = _this.getRadialFeat(contentType), shape = _c.shape, extent = _c.extent, position = _c.position;
            return (React.createElement("div", { className: className + "-feat" },
                React.createElement(Row, { gutter: 8 },
                    React.createElement(Col, { span: 3 },
                        React.createElement(Icon, { type: "shape", prompt: locale.shape })),
                    React.createElement(Col, { span: 21 },
                        React.createElement(RadioGroup, { value: shape || _this.shape[0], size: "small", onChange: function (e) {
                                var v = e.target.value;
                                _this.onChangeType('shape', v);
                            } }, getRadioButton(_this.shape)))),
                React.createElement(Row, { gutter: 8 },
                    React.createElement(Col, { span: 3 },
                        React.createElement(Icon, { type: "extent", prompt: locale.extent })),
                    React.createElement(Col, { span: 21 },
                        React.createElement(RadioGroup, { value: extent || _this.extent[0], size: "small", onChange: function (e) {
                                var v = e.target.value;
                                _this.onChangeType('extent', v);
                            } }, Object.keys(locale.extentSelect).map(function (key) { return (React.createElement(RadioButton, { value: key, key: key },
                            React.createElement(Icon, { type: key, prompt: locale.extentSelect[key] }))); })))),
                React.createElement(RowHelp, { title: React.createElement(Icon, { type: "imagePosition", prompt: locale.radialPosition }), help: locale.position_help },
                    React.createElement(SelectInput, { style: { width: '100%' }, value: position || 'center', size: "small", onChange: function (e) {
                            _this.onChangeType('position', e);
                        } }, getOptionArray(_this.position)))));
        };
        _this.pos = {};
        _this.shape = ['circle', 'ellipse'];
        _this.extent = ['farthest-corner', 'farthest-side', 'closest-corner', 'closest-side'];
        _this.position = ['center', 'center left', 'center right', 'top', 'top left',
            'top right', 'bottom', 'bottom left', 'bottom right'];
        _this.state = __assign(__assign({}, _this.getGradientData(props)), { active: 0, $self: _this });
        return _this;
    }
    GradientEdit.getDerivedStateFromProps = function (props, _a) {
        var prevProps = _a.prevProps, $self = _a.$self;
        var nextState = {
            prevProps: props,
        };
        if (prevProps && prevProps.type !== props.type) {
            $self.percentRef.state.value = 0;
            nextState = __assign(__assign(__assign({}, nextState), $self.getGradientData(props)), { active: 0 });
        }
        return nextState;
    };
    GradientEdit.prototype.componentDidMount = function () {
        window.addEventListener('mousemove', this.onPointMove);
        window.addEventListener('mouseup', this.onPointUp);
    };
    GradientEdit.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, locale = _a.locale;
        var _b = this.state, active = _b.active, gradient = _b.gradient, repeat = _b.repeat;
        var point = gradient.map(function (item, i) {
            var left = item[1];
            left = parseFloat(left) > 100 ? '100%' : left;
            left = parseFloat(left) < 0 ? '0%' : left;
            var classNames = classnames(className + "-point", {
                active: active === i,
            });
            var style = {
                left: left,
            };
            if (active === i) {
                style.backgroundColor = item[0];
            }
            return (React.createElement("div", { className: classNames, style: style, key: i.toString(), onClick: function (e) {
                    if (e.stopPropagation) {
                        e.stopPropagation();
                    }
                    else {
                        e.cancelBubble = true;
                    }
                }, onMouseDown: function (e) {
                    _this.onPointClick(e, i);
                }, onMouseUp: _this.onPointUp, onContextMenu: _this.onPointUp }));
        });
        var value = gradient[active];
        var featChild = this.getFeatChildToRender();
        return (React.createElement("div", { className: className },
            React.createElement(Row, { gutter: 8, key: "repeat", className: className + "-color" },
                React.createElement(Col, { span: 21 },
                    React.createElement(Checkbox, { onChange: this.onRepeatChange, checked: repeat }, locale.repeatGradient)),
                React.createElement(Col, { span: 3 },
                    React.createElement(Icon, { type: "question-circle", prompt: locale.barHelp }))),
            React.createElement("div", { className: className + "-bar", style: {
                    backgroundImage: "linear-gradient(to right, " + gradient.map(function (item) { return item.join(' '); }).join(',') + "), url(" + alphaBg + ")"
                }, onClick: this.onBarClick, ref: function (c) {
                    _this.bar = c;
                } },
                React.createElement("div", { className: className + "-bar-item" }, point)),
            React.createElement(Row, { gutter: 8, key: "color", className: className + "-color" },
                React.createElement(Col, { span: 16, gutter: 0 },
                    React.createElement(Color, { span: [5, 7, 12], title: React.createElement(Icon, { type: "bg-colors", prompt: locale.color }), color: colorLookup[value[0]] || value[0], onChange: function (e, isDrag) {
                            _this.onColorChange(e, isDrag);
                        } })),
                React.createElement(Col, { span: 8 },
                    React.createElement(Input, { defaultValue: parseFloat(value[1] || ''), ref: function (c) { _this.percentRef = c; }, size: "small", addonAfter: "%", onChange: this.onPercentChange, onBlur: this.onPercentBlur, onPressEnter: this.onPercentPressEnter }))),
            featChild));
    };
    GradientEdit.propTypes = {
        className: PropTypes.string,
        locale: PropTypes.object,
        value: PropTypes.any,
        onChange: PropTypes.func,
        num: PropTypes.number,
        type: PropTypes.string,
    };
    GradientEdit.defaultProps = {
        className: 'editor-gradient',
    };
    return GradientEdit;
}(React.Component));
export default polyfill(GradientEdit);
